import React from 'react';
import { useI18n } from './i18n';

// Archive of ASPI sheets. Props: sheets (API objects), onSelect(sheet).
function AspiList({ sheets, onSelect }) {
  const { t, tc, formatDate, formatNumber } = useI18n();
  if (sheets.length === 0) {
    return <div className="empty-state">{t('aspi.list.empty')}</div>;
  }

  return (
    <div className="sheets-list">
      <h2>{t('aspi.list.title')}</h2>
      <div className="cards">
        {sheets.map((s) => (
          <div key={s.id} className="card" onClick={() => onSelect(s)}>
            <div className="card-header">
              <h3>{s.wine_name}</h3>
              {s.vintage && <span className="vintage">{s.vintage}</span>}
            </div>
            <div className="card-body">
              {s.producer && <p>{s.producer}</p>}
              {s.production_area && <p className="area">{s.production_area}</p>}
              {(s.classification || s.wine_type) && (
                <p className="area">{[s.classification && tc('classification', s.classification), s.wine_type && tc('wine_type', s.wine_type)].filter(Boolean).join(' · ')}</p>
              )}
              <div className="card-scores">
                <span title={t('aspi.list.olfactory_title')}>{t('aspi.list.olfactory')}: {s.olfactory_quality}/5</span>
                <span title={t('aspi.list.gustatory_title')}>{t('aspi.list.gustatory')}: {s.gustatory_quality}/5</span>
                <span title={t('aspi.p.harmony')}>{t('aspi.list.harmony')}: {s.harmony}/5</span>
              </div>
              {s.final_score && (
                <div className="card-score-final">{t('aspi.list.pts', { n: formatNumber(s.final_score) })}</div>
              )}
            </div>
            <div className="card-footer">
              {formatDate(s.tasting_date) || '—'} {s.taster ? `· ${s.taster}` : ''}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AspiList;
